// tslint:disable:max-line-length

import React from 'react';

export const ArrowChevronLeft = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M9.5,0L4.2,6.6L3,8l1.2,1.4L9.4,16H13l-0.1-0.1L6.5,8L13,0H9.5L9.5,0z" />
    </svg>
  );
};
